import { Link } from "react-router-dom";
import { siteNav, siteAbout } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center font-heading text-xl font-bold">
                幂
              </span>
              <span className="font-heading text-lg font-bold text-background-50">杨幂资讯站</span>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed max-w-md">
              专注杨幂影视作品介绍与最新动态的粉丝资讯平台，为关注杨幂的你提供权威、清晰、及时的内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="/#nav">站点导航</a>
            </h4>
            <ul className="space-y-2.5">
              {siteNav.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-sm text-background-200/80 hover:text-accent-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="/#contact">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                {siteAbout.contact.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-accent-400" />
                {siteAbout.contact.weibo}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © {year} 杨幂资讯站 · 本站为粉丝资讯演示平台，内容为演示数据
          </p>
          <p className="text-xs text-background-200/60">影视作品 · 最新动态 · 明星资讯</p>
        </div>
      </div>
    </footer>
  );
}